import React, { useEffect, useState } from 'react';
import style from './index.module.scss';
import { useRouter } from 'next/router';
import H5Image from 'web-materials/dist/esm/components/common/H5Image';
import LogDiv from '@/commonComponents/logDiv';
import { postWithAuth, sendPoint } from '@/util';
import { useToast } from '@/stores/ToastContext';

export default () => {
  const router = useRouter();
  const [canRetry, setCanRetry] = useState(false);

  const showToast = useToast();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const canRetry = params.get('can_retry');
    canRetry && setCanRetry(true);
    const platform = params.get('platform');
    const id = params.get('id');
    const fetchStatus = async () => {
      sendPoint({ event_name: 'duet_phone_website_purchase_failed_page_insufficient_balance_retry' });
      const res = await postWithAuth(`/web/payment/${platform}/pay`, { id });
      if (res?.meta?.code === 401000) {
        router.push('/');
      } else if (res?.meta?.code === 40050) {
        showToast('You have already purchased this item and cannot buy it again.');
        sendPoint({ event_name: 'duet_phone_website_purchase_failed_page_notsupport_toast.shown' });
      } else if (res?.meta?.code === 40006002) {
        showToast(
          'Sorry, the order exceeds the payment limit of selected payment method. Please choose other payment methods'
        );
        sendPoint({ event_name: 'duet_phone_website_purchase_failed_page_notsupport_toast.shown' });
      } else {
        sendPoint({
          event_name: 'duet_phone_website_purchase_failed_page_purchase.success',
        });
        const targetUrl = res?.data?.transactionUrl;

        if (targetUrl) {
          router.push(targetUrl);
        } else {
          console.log('Payment API successful but no targetUrl received');
        }
      }
    };
    canRetry && fetchStatus();
  }, []);

  return (
    <LogDiv className={style.wrapper} impr="duet_phone_website_purchase_failed_page">
      <H5Image
        type="origin"
        className={style.back}
        onClick={() => router.push('/playground_mobile')}
        src="https://cdn.duetapp.net/v1/images/eyJpZCI6IkNSQkRaQUxFWFIzR1g3QzdHMzdZNFJJUktSN0FUUCIsInciOjU2LCJoIjo1NiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjU2NjI1MjgwMDI0NjI3Mn0"
        alt=""
      />
      <H5Image
        type="origin"
        className={style.res}
        src="https://cdn.duetapp.net/v1/images/eyJpZCI6IjJQQjVQUEtOQUhIR0VRSDRSN1g2VzVZWVg2SElZNCIsInciOjIyNiwiaCI6MTkyLCJkIjowLCJtdCI6ImltYWdlL2pwZWciLCJkaCI6MTM1MTY0NTIxMTI5MjI4MTgwOTF9"
        alt=""
      />
      <div className={style.title}>Payment Unsuccessful</div>
      <div className={style.content}>
        {canRetry
          ? 'Insufficient balance. Please top up or use another card to purchase.'
          : " Payment unsuccessful. We recommend completing your purchase through In-App Purchase—it's faster and doesn't require re-entering your card details."}
      </div>
      <LogDiv click="duet_phone_website_purchase_failed_page_go_to_appstore">
        <a
          href="https://duet.onelink.me/GBnZ/t3682sma"
          className={style.button}
          target="_blank"
          rel="noreferrer"
          suppressHydrationWarning
        >
          OK
        </a>
      </LogDiv>
    </LogDiv>
  );
};
